import * as signalR from '@microsoft/signalr';

let connection = new signalR.HubConnectionBuilder()
      .withUrl(process.env.REACT_APP_API_URL + '/api/tasksHub')
      .withAutomaticReconnect()
      .build();

export default connection;